import axiosInstance from '../../api/axiosConfig'
import {centersFindAllResponse} from './interfaces'
//antes llamado Centros, se cambió a locales
const path = '/orgventas_x_locales'

export const getCenters = async (): Promise<centersFindAllResponse> => {
  try {
    const response = await axiosInstance.post<centersFindAllResponse>(path + '/find_all', {
      filters: [
        {
          campo: 'IdOrgV',
          operador: 'EQ',
          tipo: 'string',
          valor1: 'TRC',
          valor2: 'string',
        },
      ],
      cantidad_max: '0',
      Language: 'ES',
    })
    return response.data
  } catch (error) {
    console.error('Error fetching products:', error)
    throw error
  }
}
